import styles from "./NumericInput.module.css";
import { type NumberFormatValues, NumericFormat, type NumericFormatProps } from "react-number-format";
import { useI18n } from "../../i18n";
import classNames from "classnames";
import { useRef, type JSX } from "react";

export type NumericInputProps = {
  decimalScale?: number;
  onValueChanged?: (value: number | undefined) => void;
  showCurrencySymbol?: boolean;
  hasError?: boolean;
  value: number | undefined;
} & NumericFormatProps;

const NumericInput = (props: NumericInputProps): JSX.Element => {
  const { decimalScale = 0, showCurrencySymbol = true, onValueChanged, value, hasError = false, ...rest } = props;
  const { locale } = useI18n();
  const inputClassNames = classNames(styles.input, { [styles.error]: hasError });
  const ref = useRef<HTMLInputElement>(null);
  return (
    <NumericFormat
      className={inputClassNames}
      onValueChange={(value: NumberFormatValues) => {
        if (onValueChanged != null) {
          onValueChanged(value.floatValue);
        }
      }}
      thousandSeparator={locale.thousandSeparator}
      decimalSeparator={locale.decimalSeparator}
      decimalScale={decimalScale}
      suffix={showCurrencySymbol ? " " + locale.currencySymbol : undefined}
      allowNegative={false}
      value={value}
      getInputRef={ref}
      tabIndex={0}
      {...rest}
    />
  );
};

export { NumericInput };
